import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, Column } from './common/Ant'
import { Anchor } from './common/Anchor'
import { Bread, Crumb } from './common/Bread'
import SearchFilter from './common/SearchFilter'
import { escapeRegExp } from '../utils/helpers'

const EMPTY_QUERY = {}

class InternalReports extends Component {
  static propTypes = {
    reports: PropTypes.arrayOf(PropTypes.object),
    baseUrl: PropTypes.string.isRequired,
  }

  static defaultProps = {
    reports: [],
  }

  state = {
    searchText: '',
  }

  setSearchText = searchText => this.setState({ searchText })

  noopFetch = () => {}

  filterByName = (reports, searchText) => {
    if (!searchText) {
      return reports
    }

    const regex = new RegExp(escapeRegExp(searchText), 'gi')

    return reports.filter(r => r.name && r.name.match(regex))
  }

  render() {
    const { reports, baseUrl } = this.props
    const { searchText } = this.state
    const data = this.filterByName(reports, searchText)

    const emptyText =
      searchText && data.length === 0
        ? 'No reports match your search.'
        : 'No internal reports are available yet.'

    return (
      <section className="mb5 InternalReports">
        <div className="mb3">
          <div className="mb2">
            <Bread>
              <Crumb>Internal Reports</Crumb>
            </Bread>
          </div>
        </div>
        <SearchFilter
          searchText={searchText}
          setSearchText={this.setSearchText}
          getItems={this.noopFetch}
          query={EMPTY_QUERY}
          placeholder="Search report names"
        />
        <Table
          bordered
          dataSource={data}
          rowKey="id"
          tableLayout="auto"
          locale={{
            emptyText,
          }}
          pagination={false}
        >
          <Column
            title="Report"
            dataIndex="name"
            width="40%"
            render={(text, record) => (
              <Anchor to={`${baseUrl}/${record.slug}`}>{text}</Anchor>
            )}
          />
          <Column title="Description" dataIndex="description" />
        </Table>
      </section>
    )
  }
}

export default InternalReports
